import { computed } from 'vue';
import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useChannels = defineStore('channels', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.channel_ListChannels,
    dto: 'ChannelDto',
    create: api.channel_CreateChannel,
    update: api.channel_UpdateChannel,
    delete: api.channel_DeleteChannel,
    signalR: 'ChannelUpdate',
  });

  const firstChannel = computed(() => globalStoreBase.loaded.value[0]);

  return { ...globalStoreBase, firstChannel };
});
